import { useState } from 'react'

import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { TestPrepProductAPIStat } from '~/redux/apis/user-stats-api'

import ProductCardContainer from '../ProductCardContainer'

import Details from './Details'
import Summary from './Summary'

export default function TestPrepProductCard({ product }: { product: TestPrepProductAPIStat }): React.ReactElement {
  const [showContent, setShowContent] = useState(false)

  const cardName = product.id

  const onToggle = (): void => {
    statisticsAnalytics.logProductCardToggle({ cardName, expanded: !showContent })
    setShowContent((prev) => !prev)
  }

  return (
    <ProductCardContainer innerClassName="border-2 flex flex-col gap-4">
      <Summary onClick={onToggle} product={product} showContent={showContent} />
      {showContent && <Details product={product} />}
    </ProductCardContainer>
  )
}
